import { unEscapeHTML } from "@_utils/helpers";

/**
 * Splits arbitrary user-typed free text (e.g. a note or cancellation
 * "additional details") into display lines and un-escapes any HTML entities
 * (e.g. `&amp;`, `&#39;`) so the text renders naturally.
 *
 * Trailing newlines are trimmed to avoid a blank last line.
 *
 * @param {string} text - Raw free text as returned by the backend.
 * @returns {string[]} Array of lines ready to render.
 */
export function parseTextLines(text) {
  return unEscapeHTML(text ?? "")
    .replace(/[\r\n]+$/, "")
    .split(/(?:\r\n|\r|\n)/g);
}

/**
 * Decides whether parsed note lines need an expand/collapse toggle: true when
 * the note spans multiple lines, or its single line is too long to fit.
 *
 * The `maxChars` threshold is caller-specific because it depends on the render
 * width/font size (e.g. NoteActivityCard's 16px line vs. the smaller 12px
 * cancellation line).
 *
 * @param {string[]} lines - Lines produced by `parseTextLines`.
 * @param {number} maxChars - Max length a single line may have before it needs truncation.
 * @returns {boolean}
 */
export function noteLinesNeedExpand(lines, maxChars) {
  return lines.length > 1 || (lines.length === 1 && lines[0].length > maxChars);
}
